import { createFeatureSelector, createSelector } from '@ngrx/store';
import { PromptRegisterState, promptRegisterFeatureKey } from './prompt-register.reducer';

const promptRegisterSelector = createFeatureSelector<PromptRegisterState>(promptRegisterFeatureKey);

export const selectFilters = createSelector(promptRegisterSelector, (state) => {
   return state.filters;
});
